import {FilledRects} from "@game/ui/components/Capturing/FilledRects";

type SvgCapturingProgressProps = {
    width: number;
    height: number;
    captured: number;
    stages: number;
};

export const SvgCapturingProgress = ({
    width,
    height,
    captured,
    stages
}: SvgCapturingProgressProps) => {
    const pad = 10;
    const gap = 5;
    const maskWidth = width - 2 * pad;
    const stageWidth = (maskWidth - gap * (stages + 1)) / stages;
    const stageHeight = height - 2 * pad;

    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width={width}
                height={height}
                rx={height / 2}
                fill="#FEEB5D"
                className="background"
            />

            <FilledRects
                fill="#B3B3B3"
                stages={stages}
                width={width}
                height={height}
                pad={pad}
                gap={gap}
            />
            <mask
                id="mask-capturing"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width={width}
                height={height}
            >
                <rect width={width * captured} height={height} fill="#000" />
            </mask>
            <g mask="url(#mask-capturing)">
                <FilledRects
                    fill="#77D982"
                    stages={stages}
                    width={width}
                    height={height}
                    pad={pad}
                    gap={gap}
                />
            </g>
        </svg>
    );
};
